import { ListItemText, MenuItem, Select, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Return_Policy_Enum } from '@kheops/graphql';

export interface ReturnPolicySelectProps {
  value: Return_Policy_Enum;
  onChange: (policy: Return_Policy_Enum) => void;
}

export default function ReturnPolicySelect({ onChange, value }: ReturnPolicySelectProps): React.JSX.Element {
  const { t } = useTranslation(['settings']);

  return (
    <Select
      fullWidth
      variant="outlined"
      onChange={(e) => onChange(e.target.value as Return_Policy_Enum)}
      value={value}
      displayEmpty
      renderValue={(selected) => (
        !selected
          ? <Typography sx={{color:'placeholder.main'}}>{t('settings:return_policy.values.placeholder')}</Typography>
          : t(`settings:return_policy.values.${selected.toLowerCase()}`)
      )}
    >
      <MenuItem value={Return_Policy_Enum.Full}>
        <ListItemText primary={t('settings:return_policy.values.full')} />
      </MenuItem>
      <MenuItem value={Return_Policy_Enum.Partial}>
        <ListItemText primary={t('settings:return_policy.values.partial')} />
      </MenuItem>
    </Select>
  );
}
